import React from 'react';
import Th from './th';

export default ({
  field,
  label,
  width,
  sort,
  onSort,
  alignCenter = true,
  sticky = true,
  backgroundColor,
  color,
  title
}) => {

  const renderIcon = () => {
    if (!sort || sort.field !== field) return null;

    return sort && sort.direction === 'asc'
      ? <i className="fas fa-sort-amount-down-alt" />
      : <i className="fas fa-sort-amount-up" />;
  };

  return (
    <Th
      sticky={sticky}
      alignCenter={alignCenter}
      width={width}
      backgroundColor={backgroundColor || '#1F3066'}
      color={color || '#ffffff'}
      paddingTop={2}
      paddingBottom={2}
      style={{ cursor: 'pointer', userSelect: 'none' }}
      title={title}
      onClick={() => {
        if (onSort) {
          onSort(field)
        }
      }}
    >
      {label} {renderIcon()}
    </Th>
  );
};
